import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import { approachContent } from "./industriesContent";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const IndustriesApproach = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="industries-approach-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="industries-approach-heading"
        title={approachContent.title}
        subtitle={approachContent.subtitle}
      />
      <p className="mx-auto max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {approachContent.intro}
      </p>
      <p className="mx-auto mt-6 max-w-3xl text-center text-sm md:text-base font-semibold text-gray-900">
        {approachContent.focusLabel}
      </p>
      <motion.ul
        className="mx-auto mt-6 grid max-w-4xl list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 lg:grid-cols-3"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {approachContent.focus.map((item) => (
          <motion.li
            key={item}
            variants={itemVariants}
            className="flex items-start gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-sm"
          >
            <FiCheckCircle
              aria-hidden="true"
              size={20}
              className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
            />
            <span className="text-sm md:text-base text-gray-700">{item}</span>
          </motion.li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default IndustriesApproach;
